import { gql } from "@apollo/client";

export const featureFlagsQuery = gql`
  query feature_flags {
    feature_flags
  }
`;
